<template>
  <courses />
</template>

<script>
import Courses from "../components/Courses";

export default {
  name: "Home",

  components: {
    Courses,
  },
};
</script>
